<template>
  <v-card class="elevation-12">
    <v-toolbar dark color="primary">
      <v-toolbar-title>Alteração da Senha</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-text-field v-model="password" name="password" label="Senha" type="password"></v-text-field>
        <v-text-field v-model="password_confirmation" name="password_cnonfirmation" label="Confirmação da Senha" type="password"></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="submit" color="primary">Alterar minha senha</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ResetPassword',

  data: () => ({
    logo: require('@/assets/logo.png'),
    password: '',
    password_confirmation: ''
  }),

  created () {
    this.checkPasswordToken()
  },

  methods: {
    submit () {
      this.axios.patch(`/users/passwords/${this.$route.params.token}`, { password: this.password, password_confirmation: this.password_confirmation, pass: true })
        .then(response => this.resetSuccessful(response))
        .catch(error => this.resetFailed(error))
    },
    resetSuccessful (response) {
      this.password = ''
      this.password_confirmation = ''

      this.$swal('Senha alterada!', 'Sua senha foi alterada com sucesso.', 'success')
      this.$router.replace('/')
    },
    resetFailed (error) {
      console.error(error)
    },
    checkPasswordToken () {
      this.$axios.get(`/users/passwords/${this.$route.params.token}`)
        .catch(error => {
          console.error(error)
          this.resetFailed(error)
          this.$swal('Ops!', 'O link expirou. Solicite novamente.', 'error')
          this.$router.replace('/')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
